import React from 'react';
interface GlyphProps {
  className?: string;
  animate?: boolean;
}
/* A rising sun arching over a horizon — the signature mark */
export function SunHorizon({
  className = '',
  animate = true
}: GlyphProps) {
  return <svg viewBox="0 0 400 220" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-39">
      {/* sun rays */}
      <g className={animate ? 'animate-spin-slow' : ''} style={{
      transformOrigin: '200px 200px'
    }} data-id="element-40">
        {Array.from({
        length: 12
      }).map((_, i) => {
        const angle = i / 12 * Math.PI - Math.PI / 2;
        const x1 = 200 + Math.cos(angle) * 95;
        const y1 = 200 + Math.sin(angle) * 95;
        const x2 = 200 + Math.cos(angle) * 115;
        const y2 = 200 + Math.sin(angle) * 115;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5" data-id="element-41" />;
      })}
      </g>
      {/* sun */}
      <circle cx="200" cy="200" r="78" stroke="currentColor" strokeWidth="1.2" className={animate ? 'animate-breathe' : ''} style={{
      transformOrigin: '200px 200px'
    }} data-id="element-42" />
      <circle cx="200" cy="200" r="58" stroke="currentColor" strokeWidth="0.8" opacity="0.6" data-id="element-43" />
      {/* horizon */}
      <line x1="0" y1="200" x2="400" y2="200" stroke="currentColor" strokeWidth="1" data-id="element-44" />
    </svg>;
}
/* Three concentric arcs — community */
export function Concentric({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 200 200" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-45">
      <circle cx="100" cy="100" r="30" stroke="currentColor" strokeWidth="1" data-id="element-46" />
      <circle cx="100" cy="100" r="55" stroke="currentColor" strokeWidth="1" opacity="0.6" data-id="element-47" />
      <circle cx="100" cy="100" r="80" stroke="currentColor" strokeWidth="1" opacity="0.3" data-id="element-48" />
      <circle cx="100" cy="100" r="3" fill="currentColor" data-id="element-49" />
    </svg>;
}
/* An arched doorway — the house */
export function Archway({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 200 280" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-50">
      <path d="M30 270 L30 100 Q30 30 100 30 Q170 30 170 100 L170 270" stroke="currentColor" strokeWidth="1.2" data-id="element-51" />
      <path d="M55 270 L55 110 Q55 60 100 60 Q145 60 145 110 L145 270" stroke="currentColor" strokeWidth="0.8" opacity="0.5" data-id="element-52" />
      <line x1="0" y1="270" x2="200" y2="270" stroke="currentColor" strokeWidth="1" data-id="element-53" />
      <circle cx="100" cy="100" r="2" fill="currentColor" data-id="element-54" />
    </svg>;
}
/* Wave — ocean/movement */
export function Wave({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 400 80" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-55">
      <path d="M0 40 Q50 10 100 40 T200 40 T300 40 T400 40" stroke="currentColor" strokeWidth="1.2" data-id="element-56" />
      <path d="M0 55 Q50 30 100 55 T200 55 T300 55 T400 55" stroke="currentColor" strokeWidth="0.8" opacity="0.5" data-id="element-57" />
    </svg>;
}
/* Palm leaf — nature/place */
export function Palm({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 160 240" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-58">
      <path d="M80 240 L80 110" stroke="currentColor" strokeWidth="1" data-id="element-59" />
      {/* fronds */}
      <path d="M80 110 Q40 90 10 110 Q20 80 50 75 Q40 55 80 110" stroke="currentColor" strokeWidth="1" data-id="element-60" />
      <path d="M80 110 Q120 90 150 110 Q140 80 110 75 Q120 55 80 110" stroke="currentColor" strokeWidth="1" data-id="element-61" />
      <path d="M80 110 Q60 70 50 30 Q80 50 80 110" stroke="currentColor" strokeWidth="1" data-id="element-62" />
      <path d="M80 110 Q100 70 110 30 Q80 50 80 110" stroke="currentColor" strokeWidth="1" data-id="element-63" />
      <path d="M80 110 Q70 85 40 60 Q70 75 80 110" stroke="currentColor" strokeWidth="1" opacity="0.7" data-id="element-64" />
      <path d="M80 110 Q90 85 120 60 Q90 75 80 110" stroke="currentColor" strokeWidth="1" opacity="0.7" data-id="element-65" />
    </svg>;
}
/* Compass star — direction */
export function Compass({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 200 200" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-66">
      <circle cx="100" cy="100" r="80" stroke="currentColor" strokeWidth="1" data-id="element-67" />
      <path d="M100 25 L110 100 L100 175 L90 100 Z" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.05" data-id="element-68" />
      <path d="M25 100 L100 90 L175 100 L100 110 Z" stroke="currentColor" strokeWidth="1" data-id="element-69" />
      <circle cx="100" cy="100" r="3" fill="currentColor" data-id="element-70" />
    </svg>;
}
/* Three figures in conversation — connection */
export function Figures({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 240 160" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-71">
      {[{
      x: 50,
      y: 80
    }, {
      x: 120,
      y: 70
    }, {
      x: 190,
      y: 80
    }].map((p, i) => <g key={i} data-id="element-72">
          <circle cx={p.x} cy={p.y} r="14" stroke="currentColor" strokeWidth="1.2" data-id="element-73" />
          <path d={`M${p.x - 22} 150 Q${p.x - 22} 102 ${p.x} 102 Q${p.x + 22} 102 ${p.x + 22} 150`} stroke="currentColor" strokeWidth="1.2" data-id="element-74" />
        </g>)}
      {/* connection lines */}
      <path d="M65 75 Q92 55 105 70" stroke="currentColor" strokeWidth="0.8" opacity="0.5" strokeDasharray="2 3" data-id="element-75" />
      <path d="M135 70 Q160 55 175 75" stroke="currentColor" strokeWidth="0.8" opacity="0.5" strokeDasharray="2 3" data-id="element-76" />
    </svg>;
}
/* Mountain horizon — destination */
export function Mountain({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 240 140" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-77">
      <path d="M0 130 L60 60 L100 90 L150 30 L200 80 L240 130" stroke="currentColor" strokeWidth="1.2" data-id="element-78" />
      <line x1="0" y1="130" x2="240" y2="130" stroke="currentColor" strokeWidth="1" data-id="element-79" />
      <circle cx="195" cy="35" r="14" stroke="currentColor" strokeWidth="1" data-id="element-80" />
    </svg>;
}
/* Open door — invitation */
export function Door({
  className = ''
}: GlyphProps) {
  return <svg viewBox="0 0 160 240" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-81">
      <path d="M30 230 L30 50 Q30 20 60 20 L130 20 L130 230 Z" stroke="currentColor" strokeWidth="1.2" fill="currentColor" fillOpacity="0.03" data-id="element-82" />
      <path d="M30 230 L30 50 Q30 20 60 20 L60 230 Z" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.4" data-id="element-83" />
      <circle cx="50" cy="130" r="2" fill="currentColor" data-id="element-84" />
      <line x1="0" y1="230" x2="160" y2="230" stroke="currentColor" strokeWidth="1" data-id="element-85" />
    </svg>;
}